import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App";
import { Provider } from "react-redux";
import store from "./store/index";
import RequestButton from "./components/RequestButton";

const sendEnquiryButton = document.getElementById("lms-button");
const id = sendEnquiryButton.getAttribute("data-id");
const name = sendEnquiryButton.getAttribute("data-name");

ReactDOM.render(
  <Provider store={store}>
    <App activityId={id} activityName={name} />
  </Provider>,
  document.getElementById("lms-button")
);

const lmsButton = document.getElementById("lms-trigger-button");

if (lmsButton) {
  const d = document.createElement("div");
  d.setAttribute("id", "lms-trigger-button-container");
  lmsButton.appendChild(d);

  ReactDOM.render(
    <Provider store={store}>
      <RequestButton />
    </Provider>,
    d
  );
}

const lmsButtons = document.querySelectorAll(".lms-trigger-button");

if (lmsButtons) {
  lmsButtons.forEach(container => {
    let d = document.createElement("div");
    d.setAttribute("class", "lms-trigger-button-container");
    container.appendChild(d);

    ReactDOM.render(
      <Provider store={store}>
        <RequestButton />
      </Provider>,
      d
    );
  });
}
